import cx from 'classnames';
import PropTypes from 'prop-types';

import { MarkedText } from 'src/components/MarkedText';

import useStyles from './useStyles';

const ContentSimple = ({ className, content, markup, hideMarks }) => {
  const styles = useStyles();

  return (
    <MarkedText
      className={cx(styles.root, className)}
      text={content}
      markup={markup}
      hideMarks={hideMarks}
    />
  );
};

ContentSimple.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string.isRequired,
  markup: PropTypes.arrayOf(PropTypes.shape()),
  hideMarks: PropTypes.bool,
};

ContentSimple.defaultProps = {
  className: null,
  markup: null,
  hideMarks: false,
};

export default ContentSimple;
